import styled from 'styled-components';
import { colors } from '@alixpartners/ui-components';
import { CHART_COLORS } from '../../utils';

export const Wrapper = styled.div`
	position: relative;
	display: flex;
	height: 32px;
	width: 100%;
	align-items: center;
`;

export const StatusWrapper = styled.div`
	position: relative;
	display: flex;
	justify-content: center;
	align-items: center;
	height: 20px;
	width: 100%;
	background-color: ${({ isOverrun }) =>
		isOverrun ? CHART_COLORS.RED : CHART_COLORS.GREEN};
	opacity: 0.2;
`;

export const Text = styled.div`
	position: absolute;
	font-weight: 500;
	font-size: 10px;
	color: ${colors.grey8};
	width: 100%;
	text-align: center;
`;
